'use client';

import React, { useMemo, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { Alert } from 'antd';

import { ArrowDownIcon } from 'assets';

import { ErrorType } from 'constants/errors';
import { YandexCaptchaError } from 'constants/captcha/yandex';

import { ICaptchaErrorAlertProps } from './CaptchaErrorAlert.types';

import './CaptchaErrorAlert.styles.scss';

const SupportEmail = 'support@neopool.com';

const CaptchaErrorAlert = ({ className = '', type, ...props }: ICaptchaErrorAlertProps) => {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);

  const openClass = open ? 'np-captcha-error-alert--open' : '';

  const onChangeOpen = () => {
    setOpen(prev => !prev);
  };

  const message = useMemo(() => {
    switch (type) {
      case YandexCaptchaError.NETWORK_ERROR:
        return 'error.captcha.network.title';

      case YandexCaptchaError.JAVASCRIPT_ERROR:
        return 'error.captcha.javascript.title';

      default:
      case YandexCaptchaError.VALIDATION_ERROR:
      case ErrorType.CAPTCHA_FINAL_ERROR:
        return 'error.captcha.verification.title';
    }
  }, [type]);

  const description = useMemo(() => {
    switch (type) {
      case YandexCaptchaError.NETWORK_ERROR:
        return 'error.captcha.network.desc';

      case YandexCaptchaError.JAVASCRIPT_ERROR:
        return 'error.captcha.javascript.desc';

      default:
      case YandexCaptchaError.VALIDATION_ERROR:
      case ErrorType.CAPTCHA_FINAL_ERROR:
        return 'error.captcha.verification.desc';
    }
  }, [type]);

  return (
    <Alert
      showIcon
      type="error"
      message={t(message)}
      description={
        open ? (
          <Trans
            i18nKey={description}
            components={{
              br: <br />,
              ul: <ul />,
              li: <li />,
              Link: <NavLink to={`mailto:${SupportEmail}`}>{SupportEmail}</NavLink>,
            }}
          />
        ) : (
          ' '
        )
      }
      action={<ArrowDownIcon onClick={onChangeOpen} />}
      className={`np-captcha-error-alert ${className} ${openClass}`}
      {...props}
    />
  );
};

export default CaptchaErrorAlert;
